const urls = [
  'https://www.bss.uz',
  'https://www.cxychet.ru',
  'https://www.stroychet.ru',
  'https://buh.mcfr.kz',
  'https://med.mcfr.kz',
  'https://www.ugpr.ru',
  'https://gz.mcfr.kz',
  'https://www.tspor.ru',
  'https://www.cultmanager.ru',
  'https://www.provrach.ru',
  'https://www.dirklinik.ru',
  'https://kadry.mcfr.kz',
  'https://c-med.mcfr.kz',
  'https://www.arbitr-praktika.ru',
  'https://www.dirsalona.ru',
  'https://www.dirmagazina.ru',
  'https://www.kadry.uz/',
  'https://edu.mcfr.kz',
  'https://www.gkh.ru',
  'https://www.hr-director.ru',
  'https://www.resobr.ru',
  'https://www.kom-dir.ru',
  'https://www.menobr.ru',
  'https://www.pro-personal.ru',
  'https://www.sekretariat.ru',
  'https://www.zdrav.ru',
  'https://www.gd.ru',
  'https://www.trudohrana.ru',
  'https://www.fd.ru',
  'https://www.pro-goszakaz.ru',
  'https://www.rnk.ru',
  'https://www.zarplata-online.ru',
  'https://www.business.ru',
  'https://www.budgetnik.ru',
  'https://www.buhsoft.ru',
  'https://www.law.ru',
  'https://www.kdelo.ru',
  'https://www.gazeta-unp.ru',
  'https://www.26-2.ru',
  'https://www.glavbukh.ru',
]

export function isRegWithoutPassCase(url: string | undefined): boolean {
  if (!url) return false

  const pathArray = url.split('/')
  const host = pathArray[2]
  const origin = `${host}`

  // Ищем по вхождению, передаем только домен без протокола
  // www.26-2.ru - true
  return urls.some((url) => url.includes(origin))
}
